import React, { useEffect } from 'react';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import InputMask from 'react-input-mask';
import PropTypes from 'prop-types';
import useFormValidator from 'useFormValidator';
import _ from 'lodash';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import * as actions from '../actions';

function ExportHistoryModal({ handleClose, getReports, getEwalletReportList }) {
  const [form, setForm] = React.useState({
    date_from: '',
    date_to: '',
    type: 'WALLET_BREAKDOWN',
  });

  const validateForm = useFormValidator(form, {
    mobile_number: 'cellphone_number',
  });

  const handleDateChange = key => ({ target: { value } }) => {
    setForm({
      ...form,
      [key]: value,
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    const args = {
      ...form,
      date_from: `${moment(_.get(form, 'date_from')).format(
        'YYYY-MM-DD HH:mm'
      )}`,
      date_to: `${moment(_.get(form, 'date_to')).format('YYYY-MM-DD HH:mm')}`,
      mobile_number: _.get(form, 'mobile_number'),
    };
    getReports(args);

    handleClose();
    setTimeout(() => {
      const date = new Date();
      handleClose();
      const datedToday = {
        date_from: `${moment(
          new Date(date.setMonth(date.getMonth() - 1))
        ).format('YYYY-MM-DD')}`,
        date_to: `${moment(new Date(date.setMonth(date.getMonth() + 1))).format(
          'YYYY-MM-DD'
        )}`,
        type: 'WALLET_BREAKDOWN',
      };
      getEwalletReportList(datedToday);
    }, 2000);
  };

  const onClear = e => {
    e.preventDefault();
    setForm({
      date_from: '',
      date_to: '',
    });
  };

  const onChange = e => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(form).join(',')]);

  return (
    <form className="mt-5 px-3" onSubmit={handleSubmit}>
      <>
        <div className="d-flex mb-3">
          <h2> Export </h2>
          <button
            onClick={handleClose}
            type="button"
            className="btn btn-link ml-auto"
          >
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="form-input-group mb-2">
          <label className="label-reports font-weight-bold">
            Payment Start Date
          </label>
          <DateInputPicker
            className="full-input"
            withTime
            onChange={handleDateChange('date_from')}
            value={_.get(form, 'date_from') || ''}
            popperPlacement="right-start"
          />
        </div>

        <div className="form-input-group mb-2">
          <label className="label-reports font-weight-bold">
            Payment End Date
          </label>
          <DateInputPicker
            className="full-input"
            withTime
            onChange={handleDateChange('date_to')}
            value={_.get(form, 'date_to') || ''}
            popperPlacement="right-start"
          />
        </div>

        <div className="form-input-group">
          <label className="form-label">
            Mobile Number: {validateForm.renderMessage('mobile_number')}
          </label>
          <InputMask
            className="form-control"
            mask="639999999999"
            type="text"
            name="mobile_number"
            onChange={onChange}
            value={_.get(form, 'mobile_number')}
          />
        </div>

        <div className="buttons-modal">
          <button
            onClick={onClear}
            type="button"
            className="btn btn-primary font-weight-bold mr-2 btn-dark"
            style={{ width: 150 }}
          >
            Clear Filter
          </button>
          <button
            disabled={!validateForm.response.is_passed}
            className="btn btn-primary cms-bg-color-primary font-weight-bold"
            type="submit"
            style={{ width: 150 }}
          >
            <i className="fas fa-download mr-2" /> Export
          </button>
        </div>
      </>
    </form>
  );
}
ExportHistoryModal.propTypes = {
  getEwalletReportList: PropTypes.instanceOf(Function).isRequired,
  getReports: PropTypes.instanceOf(Function).isRequired,
  handleClose: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(ExportHistoryModal);
